<div class="modal-content" *ngIf="activeOrg$ | async as activeOrg">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Add Service / Item' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form class="row" novalidate (ngSubmit)="onSave()" [formGroup]="itemForm">
      <div class="col-12">
        <div class="form-group">
          <label for="name" class="control-label font-weight-bold">
            {{ 'Name' | translate }} *
          </label>
          <app-translatable-input
            [data]="item"
            [activeOrg]="activeOrg"
            [form]="itemForm"
            [name]="'name'"
            [sent]="sent"
            [activeLocale]="inputLocale.symbol"
            [activeLocaleFlag]="inputLocale.flag"
            (changeLocale)="onChangeInputLocale($event)"
          ></app-translatable-input>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label for="itemDescription" class="control-label">{{
            'Description' | translate
          }}</label>

          <app-translatable-textarea
            [data]="item"
            [activeOrg]="activeOrg"
            [name]="'description'"
            [form]="itemForm"
            [activeLocale]="inputLocale.symbol"
            (changeLocale)="onChangeInputLocale($event)"
          ></app-translatable-textarea>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label for="price" class="control-label font-weight-bold"
            ><span *ngIf="!isPriceGross">{{ 'Price (net)' | translate }}</span>
            <span *ngIf="isPriceGross">{{
              'Price (gross)' | translate
            }}</span></label
          >
          <div class="input-group">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="priceGross"
              name="priceGross"
              [class.is-invalid]="sent && itemForm.get('priceGross').errors"
              *ngIf="isPriceGross"
              formControlName="priceGross"
              autocomplete="chrome-off"
            />
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="price"
              name="price"
              [class.is-invalid]="sent && itemForm.get('price').errors"
              *ngIf="!isPriceGross"
              formControlName="price"
              autocomplete="chrome-off"
            />

            <!-- Validation errors -->
            <!-- Missing -->
            <span
              class="invalid-feedback order-last"
              *ngIf="
                sent &&
                (itemForm.get('price').hasError('required') ||
                  itemForm.get('priceGross').hasError('required'))
              "
              >{{ 'global.validators.required.error' | translate }}</span
            >
            <!-- Invalid number -->
            <span
              class="invalid-feedback order-last"
              *ngIf="
                sent &&
                (itemForm.get('price').hasError('invalidNumber') ||
                  itemForm.get('priceGross').hasError('invalidNumber'))
              "
              >{{ 'Invalid number' | translate }}</span
            >

            <div
              class="input-group-append"
              ngbDropdown
              placement="bottom-right"
            >
              <button
                class="btn btn-outline-secondary dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                ngbDropdownToggle
              ></button>
              <div class="dropdown-menu" ngbDropdownMenu>
                <a
                  href=""
                  class="dropdown-item"
                  (click)="onTogglePriceGross(false); (false)"
                  [class.font-weight-bold]="!isPriceGross"
                >
                  <i class="fe fe-plus-square"></i> {{ 'Net' | translate }} ({{
                    'plus tax' | translate
                  }})
                </a>
                <a
                  href=""
                  class="dropdown-item"
                  (click)="onTogglePriceGross(true); (false)"
                  [class.font-weight-bold]="isPriceGross"
                >
                  <i class="fe fe-minus-square"></i>
                  {{ 'Gross' | translate }} ({{ 'with tax' | translate }})
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group" formArrayName="taxIds">
          <label for="tax" class="control-label font-weight-bold">{{
            'Tax' | translate
          }}</label>
          <ng-container *ngIf="taxes$ | async as taxes">
            <select
              id="item-tax-{{ i }}"
              name="tax"
              class="form-control data-hj-whitelist"
              *ngFor="let control of taxIdsFA.controls; let i = index"
              [formControl]="control"
            >
              <option value="">{{ 'None' | translate }}</option>

              <option *ngFor="let tax of taxes" value="{{ tax.id }}">
                <!-- {{ tax.name }}</option> -->
                {{ tax.abbreviation }} ({{ tax._taxRates[0].rate }}%)
              </option>
            </select>
          </ng-container>
        </div>
      </div>

      <div class="col-sm-6">
        <!-- unit -->
        <div class="form-group">
          <label for="unit" class="control-label">{{
            'Unit' | translate
          }}</label>
          <input
            type="text"
            class="form-control data-hj-whitelist"
            id="unit"
            name="unit"
            placeholder="{{ 'Unit of measurement' | translate }}"
            formControlName="unit"
          />
        </div>
        <!--// unit -->
      </div>

      <div class="col-sm-6">
        <!-- Total -->
        <div class="form-group">
          <label class="control-label">{{ 'Total' | translate }}</label>
          <div class="form-control data-hj-whitelist disabled" readonly>
            {{ total }}
          </div>
        </div>
      </div>

      <!-- Advanced -->
      <div class="col-12 my-3">
        <div class="row">
          <div class="col-auto">
            <button
              class="btn btn-link text-muted p-0"
              type="button"
              (click)="showAdvanced = !showAdvanced"
            >
              {{ 'taxes.tax-add.advanced.btn-text' | translate }}
              <i
                class="fe"
                [class.fe-arrow-down]="!showAdvanced"
                [class.fe-arrow-up]="showAdvanced"
              ></i>
            </button>
          </div>
          <div class="col"><hr /></div>
        </div>
      </div>

      <ng-container *ngIf="showAdvanced">
        <!-- type -->
        <div class="col-sm-6">
          <div class="form-group">
            <label for="type" class="form-label">{{
              'items.item-add.form.type.label' | translate
            }}</label>
            <select
              type="text"
              class="form-control data-hj-whitelist"
              id="type"
              name="type"
              formControlName="type"
            >
              <option value="">
                {{ 'items.item-add.form.type.both' | translate }}
              </option>
              <option value="outgoing">
                {{ 'items.item-add.form.type.outgoing' | translate }}
              </option>
              <option value="incoming">
                {{ 'items.item-add.form.type.incoming' | translate }}
              </option>
            </select>
          </div>
        </div>
        <!--// type -->

        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-check-label mb-3" for="trackInventory"
              >{{ 'item-add.track-inventory.label' | translate }}
            </label>
            <div
              class="custom-control custom-checkbox-toggle custom-switch cursor-pointer"
            >
              <input
                name="trackInventory"
                tabindex="0"
                type="checkbox"
                class="custom-control-input"
                id="trackInventory"
                formControlName="trackInventory"
              />
              <label class="custom-control-label" for="trackInventory"></label>
              <i
                class="fe fe-alert-triangle"
                *ngIf="itemForm.get('_components').value.length"
                ngbTooltip="{{
                  'item-add.track-inventory.disabled-has-component.tooltip'
                    | translate
                }}"
              ></i>
              <!-- Addon locked -->
              <i
                class="fas fa-lock ml-2 text-warning"
                *ngIf="
                  !itemForm.controls._components.value.length &&
                  (hasInventoryAddon$ | async) === false
                "
                (click)="itemForm.controls.trackInventory.patchValue(true)"
              ></i>
            </div>
          </div>
        </div>

        <ng-container
          *ngIf="
            itemForm.get('type').value === '' ||
            itemForm.get('type').value === 'incoming'
          "
        >
          <div class="col-sm-6">
            <div class="form-group">
              <label for="purchasePrice" class="control-label font-weight-bold"
                ><span *ngIf="!isPurchasePriceGross">{{
                  'Purchase price (net)' | translate
                }}</span>
                <span *ngIf="isPurchasePriceGross">{{
                  'Purchase price (gross)' | translate
                }}</span></label
              >
              <div class="input-group">
                <input
                  type="text"
                  class="form-control data-hj-whitelist"
                  id="purchasePriceGross"
                  name="purchasePriceGross"
                  [class.is-invalid]="
                    sent && itemForm.get('purchasePriceGross').errors
                  "
                  *ngIf="isPurchasePriceGross"
                  formControlName="purchasePriceGross"
                  autocomplete="chrome-off"
                />
                <input
                  type="text"
                  class="form-control data-hj-whitelist"
                  id="purchasePrice"
                  name="purchasePrice"
                  [class.is-invalid]="
                    sent && itemForm.get('purchasePrice').errors
                  "
                  *ngIf="!isPurchasePriceGross"
                  formControlName="purchasePrice"
                  autocomplete="chrome-off"
                />

                <!-- Validation errors -->
                <!-- Missing -->
                <span
                  class="invalid-feedback order-last"
                  *ngIf="
                    sent &&
                    (itemForm.get('purchasePrice').hasError('required') ||
                      itemForm.get('purchasePriceGross').hasError('required'))
                  "
                  >{{ 'global.validators.required.error' | translate }}</span
                >
                <!-- Invalid number -->
                <span
                  class="invalid-feedback order-last"
                  *ngIf="
                    sent &&
                    (itemForm.get('purchasePrice').hasError('invalidNumber') ||
                      itemForm
                        .get('purchasePriceGross')
                        .hasError('invalidNumber'))
                  "
                  >{{ 'Invalid number' | translate }}</span
                >

                <div
                  class="input-group-append"
                  ngbDropdown
                  placement="bottom-right"
                >
                  <button
                    class="btn btn-outline-secondary dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    ngbDropdownToggle
                  ></button>
                  <div class="dropdown-menu" ngbDropdownMenu>
                    <a
                      href=""
                      class="dropdown-item"
                      (click)="onTogglePurchasePriceGross(false); (false)"
                      [class.font-weight-bold]="!isPurchasePriceGross"
                    >
                      <i class="fe fe-plus-square"></i>
                      {{ 'Net' | translate }} ({{ 'plus tax' | translate }})
                    </a>
                    <a
                      href=""
                      class="dropdown-item"
                      (click)="onTogglePurchasePriceGross(true); (false)"
                      [class.font-weight-bold]="isPurchasePriceGross"
                    >
                      <i class="fe fe-minus-square"></i>
                      {{ 'Gross' | translate }} ({{ 'with tax' | translate }})
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group" formArrayName="purchaseTaxIds">
              <ng-container *ngIf="taxes$ | async as taxes">
                <ng-container
                  *ngFor="
                    let control of purchaseTaxIdsFA.controls;
                    let i = index
                  "
                >
                  <label
                    for="item-purchase-tax-{{ i }}"
                    class="control-label font-weight-bold"
                    >{{ 'Purchase tax' | translate }}</label
                  >
                  <select
                    id="item-purchase-tax-{{ i }}"
                    name="purchaseTax"
                    class="form-control data-hj-whitelist"
                    [formControl]="control"
                  >
                    <option value="">{{ 'None' | translate }}</option>

                    <option *ngFor="let tax of taxes" value="{{ tax.id }}">
                      <!-- {{ tax.name }}</option> -->
                      {{ tax.abbreviation }} ({{ tax._taxRates[0].rate }}%)
                    </option>
                  </select>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <!-- SKU -->
        <div class="col-sm-6">
          <div class="form-group">
            <label for="SKU" class="control-label">{{
              'SKU' | translate
            }}</label>
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="SKU"
              name="SKU"
              [class.is-invalid]="itemForm.get('SKU').errors"
              formControlName="SKU"
            />
            <span class="invalid-feedback">
              <span *ngIf="itemForm.get('SKU').hasError('notUnique')">{{
                'SKU for item must be unique for organization' | translate
              }}</span>
              <span *ngIf="itemForm.get('SKU').hasError('pattern')">{{
                'SKU cannot contain spaces' | translate
              }}</span>
            </span>
          </div>
        </div>
        <!--// SKU -->

        <!-- EAN -->
        <div class="col-sm-6">
          <div class="form-group">
            <label for="EAN" class="control-label">{{
              'items.item-add.form.EAN.label' | translate
            }}</label>
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="EAN"
              name="EAN"
              formControlName="EAN"
            />
          </div>
        </div>
        <!--// EAN -->

        <!-- Components -->
        <div class="col-12">
          <hr class="mt-3 mb-4" />

          <div class="row">
            <div class="col">
              <p>
                {{ 'item-add.components.title' | translate }}
              </p>
            </div>

            <div class="col-auto ml-auto">
              <i
                class="fe fe-alert-triangle mr-2"
                *ngIf="itemForm.get('trackInventory').value"
                ngbTooltip="{{
                  'item-add.components.disabled-has-inventory.tooltip'
                    | translate
                }}"
              ></i>

              <button
                type="button"
                id="componentAddFormBtn"
                class="btn btn-outline-secondary btn-sm"
                (click)="onToggleAddingComponent(); (false)"
                [disabled]="itemForm.get('trackInventory').value"
              >
                <span *ngIf="!addingComponent">{{
                  'item-add.components.add.show-btn' | translate
                }}</span>
                <span *ngIf="addingComponent">{{
                  'item-add.components.add.hide-btn' | translate
                }}</span>
              </button>
            </div>
          </div>

          <!-- Add Component -->
          <form
            class="form-row"
            *ngIf="addingComponent"
            [formGroup]="addComponentForm"
          >
            <div class="col">
              <!-- Item search template -->
              <ng-template #componentSearchTemplate let-r="result">
                <span *ngIf="r.id"
                  ><b>{{ r.name | pepEllipsis: 50 }}</b></span
                >
                <span
                  class="ml-5 float-right"
                  *ngIf="currencyId$ | async as currencyId"
                  >{{
                    r.priceGross || r.price
                      | pepCurrency: currencyId:activeOrg.locale
                  }}</span
                >
                <span class="d-block" *ngIf="r.SKU">{{ r.SKU }}</span>
              </ng-template>

              <input
                formControlName="componentSearch"
                name="componentSearch"
                [editable]="false"
                [focusFirst]="false"
                [ngbTypeahead]="componentSearch"
                [resultTemplate]="componentSearchTemplate"
                (selectItem)="onSelectComponent($event)"
                placeholder="{{
                  'item-add.components.add.search-placeholder' | translate
                }}"
                class="form-control data-hj-whitelist"
              />

              <span
                class="loading-feedback"
                [hidden]="!loading.componentSearch"
              >
                <i class="fa fa-spinner-third fa-spin fa-md"></i>
              </span>
            </div>

            <!-- Component amount -->
            <div class="col-2">
              <input
                name="amount"
                type="text"
                class="form-control text-center data-hj-whitelist"
                formControlName="amount"
              />
            </div>

            <!-- Confirm add component -->
            <div class="col-auto">
              <button
                type="button"
                id="confirmComponentBtn"
                class="btn btn-outline-primary"
                (click)="onConfirmAddComponent()"
              >
                <i class="fa fa-check"></i>
              </button>
            </div>

            <!-- Cancel add component -->
            <div class="col-auto">
              <button
                type="button"
                class="btn btn-outline-warning"
                (click)="onCancleAddComponent()"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </form>
          <!--// Add Component -->

          <!-- Existing Components -->
          <div
            class="row mt-3"
            *ngFor="
              let cmp of itemForm.controls._components.value;
              let idx = index
            "
          >
            <div class="col">
              {{ cmp.amount }} x {{ cmp.item?.name
              }}<i
                class="fa fa-spinner-third fa-spin fa-md"
                *ngIf="loading.components"
              ></i>
            </div>
            <div class="col-auto ml-auto">
              {{ cmp.item?.SKU
              }}<i
                class="fa fa-spinner-third fa-spin fa-md"
                *ngIf="loading.components"
              ></i>
            </div>
            <div class="col-auto">
              <button
                type="button"
                class="btn btn-sm btn-link text-danger ml-auto"
                (click)="onRemoveComponent(idx); (false)"
              >
                <i class="fe fe-trash"></i>
              </button>
            </div>
          </div>
          <!--// Existing Components -->
        </div>
        <!--// Components -->

        <!-- Business Units -->
        <div class="col-12" *ngIf="hasUnitsAddon$ | async">
          <hr class="mt-3 mb-4" />

          <div class="form-group mb-2">
            <label for="unitIds" class="control-label"
              >{{ 'Business Units' | translate }}
              <i
                class="fe fe-info"
                ngbTooltip="{{ 'item-add.unitIds.subtext' | translate }}"
              ></i
            ></label>
            <ng-select
              type="text"
              class="data-hj-whitelist"
              id="unitIds"
              name="unitIds"
              formControlName="unitIds"
              [multiple]="true"
              notFoundText="{{ 'item-add.no-units' | translate }}"
            >
              <ng-option
                *ngFor="let unit of units$ | async"
                [value]="unit.id"
                >{{ unit.name }}</ng-option
              >
            </ng-select>
            <!-- formControlName="unitIds" -->
          </div>
        </div>
        <!--// Business Units -->

        <hr class="w-100" />

        <app-data-form
          class="col"
          [data]="item._data"
          [sent]="sent"
          (changed)="onChange_data($event)"
        ></app-data-form>
      </ng-container>
    </form>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" (click)="onSave()">
      <span *ngIf="!item || !item.id">{{ 'global.save' | translate }}</span>
      <span *ngIf="item && item.id">{{ 'Update' | translate }}</span>
      <span *ngIf="loading.save"
        >&nbsp; <i class="fa fa-spinner-third fa-spin fa-md fa-lg"></i
      ></span>
    </button>
  </div>
</div>
